// what each revive kit holds, without the continue: the No Moves window grants that itself when the purchase
// succeeds (see ReviveOfferController). Kits are store price points shared with the mission offers, so this is
// the only place the revive contents live - the offer row and the restore fallback are both derived from it
RewardsConfig.ReviveKits = {
    kit1: { hard: 700, boosters: { cheap: 1 } },
    kit3: { boosters: { expensive: 2 } },
    kit5: { boosters: { medium: 4 } },
    kit10: { boosters: { expensive: 5 } }
};

// shown and granted in the window: the continue as an icon on top of the contents. RewardsConfig.ReviveContinueReward
// is set by the feature or the game that owns the continue (mistakes.js, a game's src/reviveofferconfig.js); none - no icon
RewardsConfig.ReviveOfferReward = function (kit) {
    return { ...RewardsConfig.ReviveContinueReward, ...RewardsConfig.ReviveKits[kit] };
};

// granted by a restore that arrives outside the level, where hearts mean nothing: the first continue's price in hard instead
RewardsConfig.ReviveRestoreReward = function (kit) {
    const content = RewardsConfig.ReviveKits[kit];
    return { ...content, hard: (content.hard || 0) + RewardsConfig.Prolongation.hardPrice[0] };
};
